export const clearTypeName = obj => {
    const keys = Object.keys(obj)
    return keys.reduce( (acc,key) => {
        if ( key !== "__typename") {
            acc = {...acc, [key]: obj[key]}
        }
        return acc
    }, {})
}